module.exports = __webpack_public_path__ + "img/42_41.6fd9bf39.png";